import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes, FaGithub, FaLinkedin, FaFileDownload } from 'react-icons/fa';
import { Link } from 'react-scroll';

const navItems = [
  { to: 'home', label: 'Home' },
  { to: 'about', label: 'About' },
  { to: 'experience', label: 'Experience' },
  { to: 'skills', label: 'Skills' },
  { to: 'certs', label: 'Certifications' },
  { to: 'contact', label: 'Contact' },
];

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const close = () => setNav(false);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-bg/85 backdrop-blur-md border-b border-zinc-800/70'
          : 'bg-transparent'
      }`}
    >
      <nav className='max-w-6xl mx-auto h-16 flex items-center justify-between px-6 sm:px-8'>
        <Link
          to='home'
          smooth={true}
          duration={500}
          className='font-mono font-bold text-accent text-lg tracking-tight'
        >
          shan<span className='text-white'>.</span>
        </Link>

        {/* Desktop nav */}
        <ul className='hidden md:flex items-center gap-8 text-sm text-zinc-400'>
          {navItems.map((item, i) => (
            <li key={item.to} className='!px-0'>
              <Link
                to={item.to}
                smooth={true}
                duration={500}
                spy={true}
                offset={-60}
                activeClass='text-accent'
                className='hover:text-accent transition-colors duration-200'
              >
                <span className='font-mono text-accent mr-1.5'>{String(i + 1).padStart(2, '0')}.</span>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>

        {/* Resume CTA + Mobile hamburger */}
        <div className='flex items-center gap-3'>
          <a
            href='/Thanushan_Varatharajah_Resume.pdf'
            target='_blank'
            rel='noopener noreferrer'
            className='hidden sm:inline-flex items-center gap-2 px-4 py-2 text-sm rounded-full border border-accent text-accent font-semibold hover:bg-accent hover:text-bg transition-all duration-200'
          >
            <FaFileDownload className='text-xs' /> Resume
          </a>
          <button
            onClick={() => setNav(!nav)}
            className='md:hidden text-zinc-300 hover:text-accent text-xl'
            aria-label='Toggle menu'
          >
            {nav ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </nav>

      {/* Mobile menu drawer */}
      <div
        className={`md:hidden fixed inset-0 bg-bg/95 backdrop-blur-md transition-opacity duration-300 ${
          nav ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        style={{ top: '4rem' }}
      >
        <ul className='flex flex-col items-center gap-6 pt-12 text-2xl text-zinc-300'>
          {navItems.map((item, i) => (
            <li key={item.to} className='!px-0'>
              <Link
                onClick={close}
                to={item.to}
                smooth={true}
                duration={500}
                className='hover:text-accent transition-colors'
              >
                <span className='font-mono text-accent text-base mr-2'>{String(i + 1).padStart(2, '0')}.</span>
                {item.label}
              </Link>
            </li>
          ))}
          <li className='!px-0'>
            <a
              onClick={close}
              href='/Thanushan_Varatharajah_Resume.pdf'
              target='_blank'
              rel='noopener noreferrer'
              className='btn-outline mt-4'
            >
              <FaFileDownload /> Download Resume
            </a>
          </li>
        </ul>
      </div>

      {/* Floating social rail (desktop) */}
      <div className='hidden lg:flex fixed flex-col gap-4 bottom-8 left-8 z-40 after:content-[""] after:w-px after:h-24 after:bg-zinc-700 after:mx-auto'>
        <a
          href='https://github.com/Shan-V'
          target='_blank'
          rel='noopener noreferrer'
          className='text-zinc-400 hover:text-accent hover:-translate-y-0.5 transition-all duration-200'
          aria-label='GitHub'
        >
          <FaGithub size={20} />
        </a>
        <a
          href='https://www.linkedin.com/in/shan-v/'
          target='_blank'
          rel='noopener noreferrer'
          className='text-zinc-400 hover:text-accent hover:-translate-y-0.5 transition-all duration-200'
          aria-label='LinkedIn'
        >
          <FaLinkedin size={20} />
        </a>
      </div>
    </header>
  );
};

export default Navbar;
